import varakresim from "../assets/images/varak/varakresim.jpeg";
import varak from "../assets/images/varak/varak.jpeg";
import varak1 from "../assets/images/varak/varak1.jpeg";
import varak2 from "../assets/images/varak/varak2.jpeg";
import varak3 from "../assets/images/varak/varak3.jpeg";

import simresim from "../assets/images/sim/simbaski.jpeg";
import sim1 from "../assets/images/sim/sim1.jpeg";
import sim2 from "../assets/images/sim/sim2.jpeg";
import sim3 from "../assets/images/sim/sim3.jpeg";
import sim4 from "../assets/images/sim/sim4.jpeg";

import flokresim from "../assets/images/flok/flokresim.jpeg";
import flok1 from "../assets/images/flok/flok1.jpeg";
import flok2 from "../assets/images/flok/flok2.jpeg";
import flok3 from "../assets/images/flok/flok3.jpeg";
import flok4 from "../assets/images/flok/flok4.jpeg";

// import gofreresim from "../assets/images/gofre/gofrebaski.jpeg";
// import gofre1 from "../assets/images/gofre1.jpeg";
// import gofre1 from "../assets/images/gofre1.jpeg";
// import gofre1 from "../assets/images/gofre1.jpeg";

import kabartmaresim from "../assets/images/kabartma/kabartmabaski.jpeg";
import kabartma1 from "../assets/images/kabartma/kabartma1.jpeg";
import kabartma2 from "../assets/images/kabartma/kabartma2.jpeg";
import kabartma3 from "../assets/images/kabartma/kabartma3.jpeg";
import kabartma4 from "../assets/images/kabartma/kabartma4.jpeg";

import pigmentresim from "../assets/images/pigment/pigmentbaski.jpeg";
import pigment1 from "../assets/images/pigment/pigment1.jpeg";
import pigment2 from "../assets/images/pigment/pigment2.jpeg";
import pigment3 from "../assets/images/pigment/pigment3.jpeg";
import pigment4 from "../assets/images/pigment/pigment4.jpeg";
import pigment5 from "../assets/images/pigment/pigment5.jpeg";

import pvcbaski from "../assets/images/pvc/pvc3.jpeg";
import pvc1 from "../assets/images/pvc/pvc4.jpeg";
import pvc2 from "../assets/images/pvc/pvc5.jpeg";
import pvc3 from "../assets/images/pvc/pvc6.jpeg";

export const products = {
  "varak-baski": {
    title: "Varak Baskı",

    items: [
      {
        id: 1,
        image: varakresim,
      },
      {
        id: 2,
        image: varak,
      },
      {
        id: 3,
        image: varak1,
      },
      {
        id: 4,
        image: varak2,
      },
      {
        id: 5,
        image: varak3,
      },
      // Diğer ürünler buraya eklenecek
    ],
  },
  "kabartma-baski": {
    title: "Kabartma Baskı",
    items: [
      {
        id: 1,
        image: kabartmaresim,
      },
      {
        id: 2,
        image: kabartma1,
      },

      {
        id: 3,
        image: kabartma2,
      },
      {
        id: 4,
        image: kabartma3,
      },
      {
        id: 5,
        image: kabartma4,
      },
      // Diğer ürünler buraya eklenecek
    ],
  },
  "sim-baski": {
    title: "Sim Baskı",
    items: [
      {
        id: 1,
        image: simresim,
      },
      {
        id: 2,
        image: sim1,
      },
      {
        id: 3,
        image: sim2,
      },
      {
        id: 4,
        image: sim3,
      },
      {
        id: 5,
        image: sim4,
      },
      // Diğer ürünler buraya eklenecek
    ],
  },
  // "gofre-baski": {
  //   title: "Gofre Baskı",
  //   items: [
  //     {
  //       id: 1,
  //       image: gofreresim,
  //     },
  //     {
  //       id: 2,
  //       image: gofreresim,
  //     },
  //     {
  //       id: 3,
  //       image: gofreresim,
  //     },
  //     {
  //       id: 4,
  //       image: gofreresim,
  //     },
  //     {
  //       id: 5,
  //       image: gofreresim,
  //     },
  //   ],
  // },
  "flok-baski": {
    title: "Flok Baskı",
    items: [
      {
        id: 1,
        image: flokresim,
      },
      {
        id: 2,
        image: flok1,
      },
      {
        id: 3,
        image: flok2,
      },
      {
        id: 4,
        image: flok3,
      },
      {
        id: 4,
        image: flok4,
      },
    ],
  },
  "pigment-baski": {
    title: "Pigment Baskı",
    items: [
      {
        id: 1,
        image: pigmentresim,
      },
      {
        id: 2,
        image: pigment1,
      },
      {
        id: 3,
        image: pigment2,
      },
      {
        id: 4,
        image: pigment3,
      },
      {
        id: 5,
        image: pigment4,
      },
      {
        id: 6,
        image: pigment5,
      },
    ],
  },
  "pvc-baski": {
    title: "PVC Baskı",
    items: [
      {
        id: 1,
        image: pvcbaski,
      },
      {
        id: 1,
        image: pvc1,
      },
      {
        id: 2,
        image: pvc2,
      },
      {
        id: 3,
        image: pvc3,
      },
    ],
  },
  // Diğer kategoriler benzer şekilde eklenecek
};

export const categories = Object.keys(products);
